import React from 'react';
import { CircleCheckIcon, UserRoundIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Service } from '../../types/content';
interface ServiceDetailProps {
  service: Service;
}
export function ServiceDetail({
  service
}: ServiceDetailProps) {
  const {
    t
  } = useLanguage();
  const Icon = service.icon;
  return <article id={service.id} className="scroll-mt-36 border-b border-mist py-12 first:pt-0 last:border-b-0" aria-labelledby={`${service.id}-title`} data-id="element-233" data-mp="342hknd944pbm">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between" data-id="element-234" data-mp="2bd298mdjcuf6">
        <div className="flex items-center gap-4" data-id="element-235" data-mp="2gaua45w5rqvi">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-brand text-white" aria-hidden="true" data-id="element-236" data-mp="2gd6sgk5tw393">
            <Icon className="h-7 w-7" data-id="element-237" data-mp="3rqsehwge5oqe" />
          </span>
          <h2 id={`${service.id}-title`} className="text-2xl font-bold text-ink sm:text-3xl" data-id="element-238" data-mp="3rpzi9pf26hmi">
            {t(service.name)}
          </h2>
        </div>
        <p className="shrink-0 self-start rounded-full bg-gold-light px-4 py-2 text-sm font-semibold text-gold-dark" data-id="element-239" data-mp="1iqvgsqrts1bi">
          {t(service.priceRange)}
        </p>
      </div>
      <p className="mt-5 max-w-3xl text-lg leading-relaxed text-ink-soft" data-id="element-240" data-mp="18sfnqi98mhzd">{t(service.description)}</p>
      <div className="mt-8 grid gap-8 md:grid-cols-2" data-id="element-241" data-mp="14qudl4o38hsv">
        <div data-id="element-242" data-mp="14qauvlqm5pds">
          <h3 className="font-sans text-base font-semibold text-ink" data-id="element-243" data-mp="14sx4rs0z8gz6">{t({
            en: 'Benefits',
            es: 'Beneficios'
          })}</h3>
          <ul className="mt-3 space-y-2.5" data-id="element-244" data-mp="ztkf6ziq0vsw">
            {service.benefits.map(b => <li key={b.en} className="flex gap-3 text-ink" data-id="element-245" data-mp="uyy8h9nl3rf5">
                <CircleCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage-dark" aria-hidden="true" data-id="element-246" data-mp="q2puw0p1c6a3" />
                {t(b)}
              </li>)}
          </ul>
        </div>
        <div className="rounded-2xl bg-white p-6" data-id="element-247" data-mp="h087hixn97li">
          <h3 className="flex items-center gap-2 font-sans text-base font-semibold text-ink" data-id="element-248" data-mp="h32qr74x8mdc">
            <UserRoundIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-249" data-mp="c4j4t6qbvakz" />
            {t({
            en: 'Who this is for',
            es: 'Para quién es'
          })}
          </h3>
          <p className="mt-3 leading-relaxed text-ink-soft" data-id="element-250" data-mp="6h7lshimam8t">{t(service.idealFor)}</p>
        </div>
      </div>
    </article>;
}